// export action constants for reset form
export const RESET_FORM_SUBMIT = 'RESET_FORM_SUBMIT'
export const RESET_FORM_SUCCESS = 'RESET_FORM_SUCCESS'
export const RESET_FORM_RECAPTCHA = 'RESET_FORM_RECAPTCHA'
export const RESET_FORM_ERROR = 'RESET_FORM_ERROR'
export const RESET_FORM_STATE = 'RESET_FORM_STATE'
export const RESET_ERROR_STATE = 'RESET_ERROR_STATE'

// export action constants for select contact
export const SUBMIT_SELECTED_CONTACT = 'SUBMIT_SELECTED_CONTACT'
export const SELECTED_CONTACT_SUCCESS = 'SELECTED_CONTACT_SUCCESS'
export const SELECTED_CONTACT_ERROR = 'SELECTED_CONTACT_ERROR'

// export action constants for submit code
export const SUBMIT_OTP_REQUEST = 'SUBMIT_OTP_REQUEST'
export const SUBMIT_OTP_SUCCESS = 'SUBMIT_OTP_SUCCESS'
export const SUBMIT_OTP_ERROR = 'SUBMIT_OTP_ERROR'
export const UPDATE_SUBMIT_OTP_STEP = 'UPDATE_SUBMIT_OTP_STEP'
export const UPDATE_SELECT_CONTACT = 'UPDATE_SELECT_CONTACT'

// export action constants for update password
export const SUBMIT_UPDATE_PASSWORD = 'SUBMIT_UPDATE_PASSWORD'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_ERROR = 'UPDATE_PASSWORD_ERROR'

export const PERIMETER_ENABLED = 'PERIMETER_ENABLED'
export const GEORGE_RESET_PASSWORD_DISRUPTED = 'GEORGE_RESET_PASSWORD_DISRUPTED'
